module.exports = __webpack_public_path__ + "static/media/trimble-logo.42adcf6f.svg";